import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const landingViewRoutes: RouteRecordRaw[] = [
  {
    path: routes.LANDING,
    name: 'LANDING',
    component: () => import('./LandingViewPage.vue'),
  },
]
